import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scanstodo',
  templateUrl: './scanstodo.component.html',
  styleUrls: ['./scanstodo.component.scss']
})
export class ScanstodoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
